<template>
  <div class="auth-login">
    <div
      class="wrap"
      @keyup.enter="getLogin">
      <el-card class="login-wrap">
        <div class="login-hello">
          幻想万国 公众管理平台
        </div>
        <el-form
          ref="logininfo"
          :model="logininfo"
          :rules="loginrules">
          <el-form-item prop="name">
            <el-input
              placeholder="用户名"
              suffix-icon="el-icon-edit"
              :maxlength="10"
              v-model="logininfo.name" />
          </el-form-item>
          <el-form-item prop="pwd">
            <el-input
              type="password"
              placeholder="密码"
              suffix-icon="el-icon-edit"
              v-model="logininfo.pwd" />
          </el-form-item>
          <el-button
            class="login-go"
            type="primary"
            :loading="logininfo.loading"
            @click="getLogin">登陆</el-button>
        </el-form>
        <div class="beian">
          <div>v{{ version }}</div>
          <div>幻想万国科技旗下产品，版权所有</div>
          <a
            href="http://beian.miit.gov.cn/"
            target="_blank">
            粤ICP备17164727号
          </a>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import Md5 from 'md5'
  import c from '@/assets/js/config'
  import packageConfig from '../../../package.json'

  export default {
    name: 'AuthLogin',
    data() {
      return {
        version: packageConfig.version,
        logininfo: {
          name: '',
          pwd: '',
          loading: false,
        },
        loginrules: {
          name: [
            {
              required: true,
              message: '请填写',
              trigger: 'blur change',
            },
          ],
          pwd: [
            {
              required: true,
              message: '请填写',
              trigger: 'blur change',
            },
            {
              min: 3,
              message: '太短了',
              trigger: 'blur',
            },
          ],
        },
      }
    },
    created() {
      localStorage.removeItem(`${c.Storage}token`)
      this.$store.dispatch('logout')
    },
    methods: {
      async getLogin() {
        if (this.logininfo.loading) return

        try {
          await this.$refs.logininfo.validate()
        } catch (err) {
          return
        }

        this.logininfo.loading = true

        await this.$Ajax('/outer/log/login', {
          name: this.logininfo.name,
          pwd: Md5(this.logininfo.pwd),
        })
          .then(data => {
            localStorage.setItem(`${c.Storage}token`, data)
            this.$nextTick(() => {
              this.$message({
                type: 'success',
                message: '登陆成功',
                duration: 2000,
              })
            })
            if (this.$route.query.backurl) {
              this.$router.push(this.$route.query.backurl)
            } else {
              this.$router.push('/inner')
            }
          })
          .catch(() => {})

        this.logininfo.loading = false
      },
    },
  }
</script>

<style lang="scss" scoped>
.auth-login {
  .wrap {
    min-height: 100vh;
    min-width: 100vh;
    background-image: url(../../assets/login-bg.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .login-wrap {
      width: 90%;
      max-width: 500px;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      overflow: visible;

      .beian {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: -70px;
        line-height: 30px;
        left: 0;
        color: #fff;

        a {
          color: #fff;
          text-decoration: none;
        }
      }
    }

    .login-hello {
      font-size: 24px;
      text-align: center;
      margin-top: 10px;
      margin-bottom: 30px;
    }

    .login-go {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/auth/auth-login.vue